import gql from 'graphql-tag';

export const addEmail = gql`
    mutation addEmail($input: [EmailInput!]!){
      response: addEmail(inputEmail: $input){
        id
      }
    }
`;